export enum YesNoNotSureOptions {
	Yes = 'yes',
	No = 'no',
	NotSure = 'not-sure',
} 